import React, { useState } from 'react'

import {
  AnsweredReadWaive,
  READ_WAIVE_LABELS,
  ReadWaiveSelect,
} from '@/components/common/ReadWaiveSelect'
import { AttendeeFieldCard } from '@/components/Event/NewScript/components/Review/AttendeeFieldCard/AttendeeFieldCard'
import { ScriptAttendee } from '@/types'

type WitnessFieldCardProps = {
  witness: ScriptAttendee
  answer: AnsweredReadWaive
  onSubmitClick: (value: AnsweredReadWaive) => void
}

export const WitnessFieldCard: React.FC<WitnessFieldCardProps> = ({
  witness,
  answer,
  onSubmitClick,
}) => {
  const [selectedValue, setSelectedValue] = useState<AnsweredReadWaive>(answer)

  return (
    <AttendeeFieldCard
      attendee={witness}
      fieldValue={READ_WAIVE_LABELS[answer]}
      onSubmitClick={() => onSubmitClick(selectedValue)}
      onCancelClick={() => setSelectedValue(answer)}
      fieldInput={
        <ReadWaiveSelect
          value={selectedValue}
          onChange={setSelectedValue}
          label="Read or waive"
        />
      }
    />
  )
}
